import { ChevronDown, ExternalLink } from "lucide-react";
import { IMAGES } from "@/lib/api";
import { MEET_FINN } from "@/data/ocean";
import { WHY, CARDS, SOURCES } from "@/data/why";
import { ClaimNote } from "@/components/Wave";
import { MASCOT_ALT } from "@/data/seo";

export const MeetFinnBlock = ({ id }) => (
  <section data-testid={`meet-finn-${id}`} className="container-gf pb-12">
    <div className="sticker-sm bg-white p-6 grid gap-6 sm:grid-cols-[140px_1fr] items-center max-w-4xl">
      <img src={IMAGES.mascotSmall} alt={MASCOT_ALT} loading="lazy" decoding="async" width="140" height="140" className="h-[140px] w-[140px] rounded-2xl object-cover" />
      <div>
        <h2 className="text-2xl">Meet Grandpa Finn</h2>
        <p data-testid={`meet-finn-text-${id}`} className="mt-3 text-sm leading-relaxed text-slate-700">{MEET_FINN}</p>
      </div>
    </div>
  </section>
);

const Row = ({ label, children }) => (
  <div><dt className="text-[11px] font-semibold uppercase tracking-widest text-slate-500">{label}</dt><dd className="mt-1 text-sm leading-relaxed text-slate-700">{children}</dd></div>
);

const WhyCard = ({ k, id }) => {
  const c = CARDS[k];
  return (
    <div data-testid={`why-card-${id}-${k.toLowerCase()}`} className="rounded-3xl bg-white border-2 border-navy p-5">
      <p className="font-display text-lg leading-snug">{c.name}</p>
      <dl className="mt-3 space-y-3">
        <Row label="What's in your daily serving">{c.serving}</Row>
        <Row label="Its role">{c.role}</Row>
        <Row label="What the research says">{c.research}</Row>
        {c.note && <Row label="Note">{c.note}</Row>}
      </dl>
    </div>
  );
};

export const WhyStack = ({ id }) => {
  const w = WHY[id];
  if (!w) return null;
  return (
    <section data-testid={`why-stack-${id}`} className="container-gf pb-12">
      <h2 className="text-3xl">Why this stack</h2>
      <p data-testid={`why-intro-${id}`} className="mt-3 text-slate-700 max-w-3xl">{w.intro}</p>
      <div className="mt-6 grid gap-5 lg:grid-cols-3">{w.cards.map((k) => <WhyCard key={k} k={k} id={id} />)}</div>
      {w.extra && <p data-testid={`why-extra-${id}`} className="mt-5 text-sm font-semibold max-w-3xl">{w.extra}</p>}
      <details data-testid={`why-sources-${id}`} className="group mt-6 max-w-3xl">
        <summary className="cursor-pointer list-none inline-flex items-center gap-2 font-semibold underline decoration-sunny decoration-2 underline-offset-4">
          Sources <ChevronDown className="h-4 w-4 transition-transform group-open:rotate-180" />
        </summary>
        <ol className="mt-3 space-y-2 text-sm list-decimal pl-5">
          {w.sources.map((s) => (
            <li key={s}><a href={SOURCES[s][1]} target="_blank" rel="noopener noreferrer" data-testid={`why-source-${id}-${s.toLowerCase()}`} className="underline underline-offset-2 hover:text-coral">{SOURCES[s][0]} <ExternalLink className="inline h-3 w-3" /></a></li>
          ))}
        </ol>
      </details>
      <ClaimNote testId={`why-fda-${id}`} className="max-w-3xl" />
    </section>
  );
};
